module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBBc-.0774a8b7.woff";